import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import {
  Card,
  Image,
  Text,
  LicensePlate,
} from "../Index";

import Test from "../../assets/Image/car-image.webp";
import MoreIcon from "../../assets/Icon/more.svg";
import ArrowIcon from "../../assets/Icon/arrow.svg";

import "./carInfo.scss";

function CarInfo({
  carId,

  Src,
  Km,
  CarModel,
  ProductionYear,
  CarColor,

  Plate1,
  Plate2,
  Plate3,
  End,

  showMoreMenu = false,

  onSelect,
  selectable = false,
  hideSelectionUI = false,

  onEdit,
  onDelete,
  onDetails,
  onDescription,
  onService,
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuRef = useRef(null);
  const navigate = useNavigate();

  // =========================
  // بستن منو با کلیک بیرون
  // =========================

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        isMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(e.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isMenuOpen]);

  // =========================
  // باز / بسته کردن منو
  // =========================

  const toggleMenu = (e) => {
    e.stopPropagation();

    setIsMenuOpen((prev) => !prev);
  };

  // =========================
  // انتخاب ماشین
  // =========================

  const handleClick = (e) => {
    e.stopPropagation();

    if (onSelect) {
      onSelect(carId);
    }
  };

  // =========================
  // ویرایش
  // =========================

  const handleEdit = (e) => {
    e.stopPropagation();

    setIsMenuOpen(false);

    // رفتن به صفحه AddCars
    navigate("/AddCars");

    // اگر والد onEdit داشته باشد، آن را هم اجرا می‌کنیم
    if (onEdit) {
      onEdit(carId);
    }
  };

  // =========================
  // حذف
  // =========================

  const handleDelete = (e) => {
    e.stopPropagation();

    setIsMenuOpen(false);

    if (onDelete) {
      onDelete(carId);
    }
  };

  // =========================
  // جزئیات
  // =========================

  const handleDetails = (e) => {
    e.stopPropagation();

    setIsMenuOpen(false);

    if (onDetails) {
      onDetails(carId);
    }
  };

  // =========================
  // وضعیت انتخاب
  // =========================

  const showSelectableUI =
    selectable &&
    !hideSelectionUI &&
    !onSelect;

  const cardClassName =
    showSelectableUI
      ? "car-info__card car-info__card--selectable"
      : "car-info__card";

  return (
    <div className="car-info" dir="rtl">

      <Card
        className={cardClassName}
        onClick={handleClick}
      >

        {/* =========================
            منوی سه نقطه
        ========================= */}

        {showMoreMenu && (
          <div
            className="car-info__more"
            ref={menuRef}
          >

            <button
              type="button"
              className="car-info__more-button"
              onClick={toggleMenu}
              aria-label="More options"
            >
              <img
                src={MoreIcon}
                alt="more"
              />
            </button>

            {isMenuOpen && (
              <div className="car-info__menu">

                <button
                  type="button"
                  onClick={handleEdit}
                >
                  ویرایش
                </button>

                <button
                  type="button"
                  onClick={handleDelete}
                >
                  حذف
                </button>

                <button
                  type="button"
                  onClick={handleDetails}
                >
                  جزئیات
                </button>

              </div>
            )}

          </div>
        )}

        {/* =========================
            اطلاعات ماشین + تصویر
            Unified dashboard-card design (desktop = source of truth):
            one RTL row at EVERY width (details right, image left),
            plate bar below. Smaller screens only scale it fluidly.
        ========================= */}

        <div className="car-info__body">

          <div className="car-info__details">

            <div className="car-info__km">
              <Text
                size="mini"
                FontSize="lg"
                FontWight="Bold"
              >
                کیلومتر {Km}
              </Text>
            </div>

            <div className="car-info__row">
              <Text
                size="mini"
                FontSize="sm"
              >
                {CarModel}
              </Text>
            </div>

            <div className="car-info__row">
              <Text
                size="mini"
                FontSize="sm"
              >
                سال ساخت : {ProductionYear}
              </Text>
            </div>

            <div className="car-info__row">
              <Text
                size="mini"
                FontSize="sm"
              >
                رنگ : {CarColor}
              </Text>
            </div>

          </div>

          {/* =========================
              تصویر ماشین
              Fluid width; the img renders at its NATURAL aspect ratio
              (height auto) so it is never stretched, squashed, or
              cropped at any screen size.
          ========================= */}

          <div className="car-info__media">
            <Image
              src={Src || Test}
              alt={CarModel || "تصویر خودرو"}
            />
          </div>

        </div>

        {/* =========================
            پلاک
        ========================= */}

        <div className={`car-info__plate-row${onService ? " has-service-action" : ""}`}>
          <div className="car-info__plate">
          <LicensePlate
            Main1={Plate1}
            Main2={Plate2}
            Main3={Plate3}
            End={End}
          />
          </div>
          {onService && <button type="button" className="car-info__service-button" onClick={(event) => { event.stopPropagation(); onService(carId); }}>ثبت سرویس</button>}
        </div>

        {/* =========================
            فلش انتخاب
        ========================= */}

        {showSelectableUI && (
          <div className="car-info__select-indicator">

            <img
              src={ArrowIcon}
              alt="انتخاب"
              className="car-info__select-arrow"
            />

          </div>
        )}

      </Card>

    </div>
  );
}

export default CarInfo;
